// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import '@popperjs/core'
import 'bootstrap/dist/js/bootstrap'
import '@fortawesome/fontawesome-free/js/all'
import '@fortawesome/fontawesome-free/css/all'
import "../stylesheets/application"
import { Turbo } from "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import 'controllers'
import "../utils/submit_state"
import moment from 'moment-timezone'
import Trix from "trix"

// Emit app/assets/images through Shakapacker so views can use image_pack_tag.
require.context("../../assets/images", false, /\.(png|jpe?g|gif|svg)$/)

window.moment = moment
window.bootstrap = require('bootstrap/dist/js/bootstrap');
window.Turbo = Turbo
ActiveStorage.start()
